/**
 * @Description 围栏
 */

import { isArray } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { FC, useEffect, useRef } from 'react';
import { v4 } from 'uuid';
// import cs from 'classnames';
import styles from './index.module.less';
import ReactDOM from 'react-dom';
import { showMarker } from '@/common/utils/map';
import { demoForCarModelIds } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import { useSelector } from 'react-redux';
import useLatest from '@/common/hook/useLatest';

const Rail: FC<any> = ({
  mapIns,
  detail,
  isBack,
  setIsBack,
  rangeMarkerRef,
}) => {
  const curPolygonMarkerRef: any = useRef();// 当前开店区域围栏
  const circle500MarkerRef: any = useRef();
  const modelConfigId = useSelector((state: any) => state.iterate.modelConfigId); // 存放选址地图页面的当前模型
  const modelConfigIdRef = useLatest(modelConfigId);


  useEffect(() => {
    if (!mapIns) return;
    const {
      lng,
      lat,
      borders,
      radius,
    } = detail || {};

    if (!(+lng && +lat)) return;
    if (isArray(borders) && borders.length) {
      methods.createPolygon();
    } else if (radius > 0) {
      methods.createCircle(radius, true);
    }
    methods.createNameMarker();
    // 如果是特斯拉模型，那么就不展示5分钟步行圈、15分钟生活圈、外卖覆盖
    if (demoForCarModelIds.includes(modelConfigIdRef.current)) return;
    rangeMarkerRef.current.markerOf500 = methods.createCircle(500); // 5分钟步行圈
    rangeMarkerRef.current.markerOf1500 = methods.createCircle(1500); // 15分钟生活圈
    rangeMarkerRef.current.markerOf3000 = methods.createCircle(3000); // 外卖覆盖
  }, [mapIns, detail]);

  useEffect(() => { // 点击了回到商圈
    if (!mapIns) return;
    // if (!circle500MarkerRef.current) return;
    if (isBack) {
      // 如果是特斯拉模型，那么就以当前围栏展示可视区域
      if (demoForCarModelIds.includes(modelConfigIdRef.current)) {
        curPolygonMarkerRef.current && mapIns.setFitView(curPolygonMarkerRef.current, true);
      } else {
        circle500MarkerRef.current && mapIns.setFitView(circle500MarkerRef.current, true);
      }
      setIsBack(false);
    }
  }, [mapIns, isBack]);

  const methods = useMethods({
    createPolygon: () => { // 绘制围栏
      const { borders } = detail;
      const polygonMarker = new window.AMap.Polygon({
        path: borders,
        fillColor: '#006AFF',
        strokeOpacity: 1,
        fillOpacity: 0.2,
        strokeColor: '#4792FD',
        strokeWeight: 2,
      });

      mapIns.add(polygonMarker);
      // 如果是特斯拉模型，那么就以该个围栏为默认的视野
      if (demoForCarModelIds.includes(modelConfigIdRef.current)) {
        mapIns.setFitView(polygonMarker);
      };
      curPolygonMarkerRef.current = polygonMarker;
    },
    createCircle: (radius = 500, isDefault = false) => { // 绘制圆形
      const { lng, lat } = detail;
      const circleMarker = new window.AMap.Circle({
        center: [+lng, +lat],
        radius, // 半径（米）
        strokeColor: '#4792FD',
        strokeWeight: 2, // isCustom ? 10 : 2,
        strokeOpacity: 1,
        fillOpacity: 0.06,
        strokeStyle: isDefault ? 'solid' : 'dashed',
        strokeDasharray: [10, 10],
        fillColor: '#006AFF',
      });
      mapIns.add(circleMarker);
      // 如果是特斯拉模型，那么就以该个围栏为默认的视野
      if (demoForCarModelIds.includes(modelConfigIdRef.current)) {
        mapIns.setFitView(circleMarker);
        curPolygonMarkerRef.current = circleMarker;
      };
      const contentMarker = methods.createDistanceMarker(circleMarker, radius);
      if (radius === 500) {
        circle500MarkerRef.current = circleMarker;
        mapIns.setFitView(circleMarker, true);
      }
      return {
        circleMarker,
        contentMarker
      };
    },
    createNameMarker: () => {
      const uid:any = v4();
      const { lng, lat, areaName } = detail;
      const marker = new window.AMap.Marker({
        position: new window.AMap.LngLat(+lng, +lat),
        anchor: 'top-center',
        offset: [0, -34],
      });
      mapIns.add(marker); // 先添加到地图上
      marker.setContent(`<div id="${uid}"></div>`);
      ReactDOM.render(<div className={styles.textMarkerWrapper}>
        <div className={styles.textMarkerCon}>
          {areaName}
        </div>
      </div>, document.getElementById(uid));
    },

    // 不同距离围栏的标注 --  如果这里有修改，记得同时修改src/common/components/business/AreaDetailDrawer/components/FirstScreenRight/components/Basic.tsx里面的handleContentMarker
    createDistanceMarker: (circleMarker, radius) => {
      let content = '';
      switch (radius) {
        case 500:
          content = '500m(5分钟步行圈)';
          break;
        case 1500:
          content = '1.5km(15分钟生活圈)';
          break;
        case 3000:
          content = '3km(外卖覆盖)';
          break;
      }
      if (!content) return;
      // 获取最顶部的经纬度
      // ps 高德文档中的circleMarker没有getPath方法，但实际是可用的
      const topPosition = circleMarker.getPath().reduce((acc, item) => {
        if (acc.lat < item.lat) {
          acc = item;
        }
        return acc;
      });
      const marker = new window.AMap.Marker({
        position: topPosition,
        offset: [0, 20]
      });
      mapIns.add(marker);

      showMarker(marker, <div className={styles.distanceHint}>
        {content}
      </div>);
      return marker;
    }
  });
  return (
    <></>
  );
};

export default Rail;

